import { Header } from './Header';
import { useAppStore } from '../../store';
import type { ReactNode } from 'react';

export function Layout({ children, onOpenSettings, onOpenPalette }: { children: ReactNode; onOpenSettings?: () => void; onOpenPalette?: () => void }) {
  const panelOpen = useAppStore((s) => !!s.selectedTaskId);

  return (
    <div className="min-h-screen bg-bg-base flex flex-col">
      <Header onOpenSettings={onOpenSettings} onOpenPalette={onOpenPalette} />
      <main className={`flex-1 overflow-hidden transition-[margin] duration-200 ease-out ${panelOpen ? 'mr-96' : ''}`}>
        {children}
      </main>
    </div>
  );
}
